import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../api'
import { ReactComponent as CloseIcon } from '../assets/images/icons/ic-close.svg'
import styles from './FailedJobsBanner.module.css'

const FailedJobsBanner = () => {
    const [count, setCount] = useState(0)
    const [dismissed, setDismissed] = useState(false)

    useEffect(() => {
        if (dismissed) return
        let cancelled = false
        let timer
        const refresh = async () => {
            try {
                const response = await api.get('/admin/recordings-jobs?page=0&per=1&status=failed')
                if (!cancelled) setCount(Number(response.count) || 0)
            } catch (error) {
                // A failed status check must not prevent using the dashboard.
                console.error('Unable to load failed processing jobs', error)
            } finally {
                if (!cancelled) timer = setTimeout(refresh, 60000)
            }
        }
        refresh()
        return () => {
            cancelled = true
            clearTimeout(timer)
        }
    }, [dismissed])

    if (dismissed || count <= 0) return null

    return (
        <div className={styles.wrapper}>
            <div className={styles.banner} role="status">
                <span className={styles.icon} aria-hidden="true">!</span>
                <div className={styles.content}>
                    <strong>{count === 1 ? '1 job di processamento fallito' : `${count} job di processamento falliti`}</strong>
                    <span>Controlla i dettagli per verificare il problema e riprovare.</span>
                    <Link to="/jobs?status=failed">Visualizza job falliti →</Link>
                </div>
                <button type="button" className={styles.close} aria-label="Chiudi avviso job falliti" title="Chiudi avviso" onClick={() => setDismissed(true)}>
                    <CloseIcon aria-hidden="true" />
                </button>
            </div>
        </div>
    )
}

export default FailedJobsBanner
